{
  "de": {
    "issue_status": {
      "actions": {
        "create": "Punktestatus erstellen"
      },
      "labels": {
        "backup_status": "Ersatzstatus",
        "customer_status": "Kunde sieht",
        "delete_status": "Status „{name}“ löschen?",
        "delete_status_disclaimer": "Alle Nachbetreuungspunkte mit diesem Status werden dem unten ausgewählten Status zugewiesen.",
        "inbox_hint": "Standard-Status für den Posteingang",
        "internal_status": "Interner Status",
        "new_issue_status": "Status"
      }
    }
  }
}
